"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.machineJSON = exports.createApptSummaryMachine = void 0;
var _xstate = require("xstate");
var _States = require("../../lib/constants/States");
var _utils = require("../../lib/utils");
// Placeholder machine in case we need to support things like appt cancellation, going back in the flow, etc.
const machineJSON = _ref => {
  let {
    bookedAppt,
    provider,
    selectedAppointment
  } = _ref;
  return {
    id: `Machine__${_States.apptSummary}`,
    initial: _States.idle,
    context: {
      bookedAppt,
      location: (0, _utils.getApptLocation)(provider, selectedAppointment),
      provider,
      selectedAppointment
    },
    states: {
      [_States.idle]: {}
    }
  };
};
exports.machineJSON = machineJSON;
const createApptSummaryMachine = props => (0, _xstate.Machine)(machineJSON(props));
exports.createApptSummaryMachine = createApptSummaryMachine;